/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'bot-detection-policy-logs-expander';
const prefix = `${moduleName}.${componentName}`;

export const gridRowExpandedConfidenceLabel = `${prefix}.gridRowExpandedConfidenceLabel`;
export const gridRowExpandedNotesLabel = `${prefix}.gridRowExpandedNotesLabel`;

export const ENGLISH = {
    [gridRowExpandedConfidenceLabel]: 'Confidence',
    [gridRowExpandedNotesLabel]: 'Notes',
};
